// extracted by mini-css-extract-plugin
export default {"imageWrap":"ImageThumbnail_imageWrap__DbP79","noImage":"ImageThumbnail_noImage__8Wbmu"};